module.exports = __webpack_public_path__ + "static/media/car-training.7a02e912.png";